// src/api/trials/trials.ts
import { useApiClient } from "../apiClients";
import { TRIALS_ENDPOINTS } from "./endpoints";
import type { Trial, TrialApplyResponse, TrialDetail, TrialEstimate, TrialPayload } from "../../models/domain";

export const useTrialsApi = () => {
  const apiClient = useApiClient("embed");

  /** `override: {}` rend les réglages effectifs de la matière : de quoi préremplir. */
  const estimateTrial = (payload: TrialPayload) => apiClient.post<TrialEstimate>(TRIALS_ENDPOINTS.ESTIMATE, payload);

  const createTrial = (payload: TrialPayload) => apiClient.post<{ trial: Trial }>(TRIALS_ENDPOINTS.BASE, payload);

  const listTrials = () => apiClient.get<{ trials: Trial[] }>(TRIALS_ENDPOINTS.BASE);

  const getTrial = (trialId: string) => apiClient.get<TrialDetail>(TRIALS_ENDPOINTS.DETAIL(trialId));

  /** `saveSettings` : la surcharge devient le réglage de la matière. */
  const applyTrial = (trialId: string, saveSettings: boolean) =>
    apiClient.post<TrialApplyResponse>(TRIALS_ENDPOINTS.APPLY(trialId), { save_settings: saveSettings });

  /** Un essai en cours est arrêté puis jeté ; un essai appliqué ne se jette pas (409). */
  const discardTrial = (trialId: string) => apiClient.delete<{ trial: Trial }>(TRIALS_ENDPOINTS.DETAIL(trialId));

  return { estimateTrial, createTrial, listTrials, getTrial, applyTrial, discardTrial };
};
